
jQuery(document).ready(function($) {
		  
	// ##############################################
	// ############## Header-Functions ##############
	// ##############################################
				
	// Sticky-Header und responsive Nav
	if ($(window).width() < 992) {
		var $offsetStickyNav = 105;
	} else {
		var $offsetStickyNav = 105;
	}
	  
	$(window).resize(function() {
		if ($(window).width() < 992) {
			$offsetStickyNav = 105;
      $('.primary-nav .dropdown').removeClass('show');
      $('.primary-nav .dropdown').find('.dropdown-menu').removeClass('show');
		} else {
			$offsetStickyNav = 105;
			$('body').removeClass('pushy-open-right');
		}
	});
  
	(function () {
    	var footer = $('body footer').get(0);
    	var top;
    	var scrollPos = $(window).scrollTop();
      var vh = $(window).outerHeight();
      $(window).resize(function () {
          scrollPos = $(window).scrollTop();
          vh = $(window).outerHeight();
      });
      //var scrollToTop =  $('.scrollToTop');
    	
    	var relative = false;
    	var visible = false;
    	//var stickyNav = false;
      
      //if (stickyNav != (scrollPos >= $navHeight)) {
      //    stickyNav = scrollPos >= $navHeight;
      //    $('header').toggleClass('sticky-nav', stickyNav);
      //}
    	
      $(window).scroll(function () {
          scrollPos = $(window).scrollTop();
          
          if (footer) {
            top = footer.getBoundingClientRect().top;
            if ((top < vh) != relative) {
                relative = top < vh;
                //scrollToTop.toggleClass('relative', relative);
            }
          }
          
          if (visible != (scrollPos > 250)) {
              visible = scrollPos > 250;
              //scrollToTop.fadeToggle(visible);
          }
          
          //if (stickyNav != (scrollPos >= 50)) {
          //    stickyNav = scrollPos >= 50;
          //    $('header').toggleClass('sticky-nav', stickyNav);
          //}
          
      });  
        	
  }())
  
    // Add slideDown animation to Bootstrap dropdown when expanding.
    $('.primary-nav .dropdown').on('show.bs.dropdown', function() {
      console.log('Show');
      $(this).find('.dropdown-menu').first().stop(true, true);
      $(this).find('.dropdown-menu > .dropdown-menu-inner').slideDown('400');
    });
  
    // Add slideUp animation to Bootstrap dropdown when collapsing.
    $('.primary-nav .dropdown').on('hide.bs.dropdown', function() {
      console.log('Hide');
      $(this).find('.dropdown-menu').first().stop(true, true);
      $(this).find('.dropdown-menu > .dropdown-menu-inner').slideUp('400');
    });
  
  

  // ##############################################
	// ################# Pushy-Nav ##################
	// ##############################################

  $('.pushy-submenu').each(function () {
  	if ($(this).hasClass('active')) {
      //console.log($(this));
      $(this).removeClass('active');
      $(this).removeClass('pushy-submenu-closed');
      $(this).addClass('pushy-submenu-open');
    }
	});  
  
	// ##############################################
	// ################ Anchor-Link #################
	// ##############################################  
  
  $(".anchor-link").click(function(event) {
    if ($(this.hash).offset()) {
      event.preventDefault();
      var $navOffset = $offsetStickyNav;
      var $target = $(this.hash);
       $('html,body').animate( { scrollTop:($target.offset().top - $navOffset)} , 800);
    }
  });	
  
	// ##############################################
	// ################ Page Scroll #################
	// ##############################################

  var hash = window.location.hash;
  if (hash.length && hash != '#pig' && hash != '#poultry' && hash != '#cattle' ) {
    $('body, html').scrollTop(0);
    $('body').imagesLoaded(function() {
      if ($(hash).offset()) {
        setTimeout(function(){
          $('html,body').animate( { scrollTop:($(hash).offset().top)} , 800);
        }, 1000);        
      }
    });
  }
      

});

